export function initTsum() {
  document.documentElement.classList.add('tsum')
}
